import React from "react";
import "./index.css";

export default function AnimatedCheckmark({
  className = "",
  style = {},
  ...props
}) {
  return (
    <svg className="gc__checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <circle className="gc__checkmark_circle" cx="26" cy="26" r="25" fill="none"/>
      <path className="gc__checkmark_check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
    </svg>
  );
}
